export const legalEl = {
  footer: { privacy: "Πολιτική Απορρήτου", terms: "Όροι Χρήσης", deleteAccount: "Διαγραφή Λογαριασμού" },
  privacy: {
    meta: {
      title: "Πολιτική Απορρήτου | GetTaxcy",
      description: "Πώς το GetTaxcy συλλέγει, χρησιμοποιεί και προστατεύει τα προσωπικά δεδομένα επιβατών και οδηγών σύμφωνα με τον ΓΚΠΔ της ΕΕ.",
    },
    md: `
# Πολιτική Απορρήτου GetTaxcy
Τελευταία ενημέρωση: 3 Νοεμβρίου 2026
Το GetTaxcy («εμείς») λειτουργεί την εφαρμογή επιβατών GetTaxcy, την εφαρμογή GetTaxcy Driver και την ιστοσελίδα gettaxcy.com. Η παρούσα πολιτική εξηγεί ποια προσωπικά δεδομένα συλλέγουμε, για ποιο λόγο, καθώς και τα δικαιώματά σας σύμφωνα με τον Γενικό Κανονισμό για την Προστασία Δεδομένων της ΕΕ (ΓΚΠΔ).
## Ποιοι είμαστε
Υπεύθυνος επεξεργασίας: Γεώργιος Κεσίδης, με την εμπορική επωνυμία GetTaxcy
Διεύθυνση: Διαγόρου 20, Κάτω Πάφος 8042, Κύπρος
Email: costataxicy@gmail.com
Τηλέφωνο / WhatsApp: +357 99940234
## Ποια δεδομένα συλλέγουμε
**Επιβάτες**
- Στοιχεία λογαριασμού: όνομα, αριθμός τηλεφώνου, διεύθυνση email
- Τοποθεσία: σημεία παραλαβής και αποβίβασης και η τοποθεσία της συσκευής σας όσο χρησιμοποιείτε την εφαρμογή για να κλείσετε ή να παρακολουθήσετε μια διαδρομή
- Ιστορικό διαδρομών: διαδρομές, ημερομηνίες, ώρες, τιμές, στοιχεία οδηγού και οχήματος
- Στοιχεία πληρωμής: οι πληρωμές με κάρτα διεκπεραιώνονται από τη Stripe. Δεν βλέπουμε και δεν αποθηκεύουμε τον πλήρη αριθμό της κάρτας σας.
- Μηνύματα και αξιολογήσεις που στέλνετε μέσω της εφαρμογής
**Οδηγοί**
- Στοιχεία λογαριασμού: όνομα, αριθμός τηλεφώνου, διεύθυνση email, φωτογραφία προφίλ
- Έγγραφα οδηγού: άδεια οδήγησης και άδεια ταξί, στοιχεία και άδεια κυκλοφορίας οχήματος, ασφάλεια και έλεγχοι ταυτότητας που χρειαζόμαστε για να σας εγκρίνουμε
- Τοποθεσία: η τοποθεσία της συσκευής σας όσο είστε συνδεδεμένοι στην εφαρμογή οδηγού, και όταν η εφαρμογή λειτουργεί στο παρασκήνιο, ώστε να σας στέλνουμε κοντινές διαδρομές και να βλέπουν οι επιβάτες πού βρίσκεστε
- Έσοδα, προμήθειες και στοιχεία πληρωμών. Οι πληρωμές προς τους οδηγούς γίνονται μέσω Stripe Connect.
**Όλοι**
- Δεδομένα συσκευής και τεχνικά δεδομένα: τύπος συσκευής, λειτουργικό σύστημα, έκδοση εφαρμογής, αρχεία σφαλμάτων και κωδικοί (tokens) ειδοποιήσεων push
## Γιατί χρησιμοποιούμε τα δεδομένα σας
- Για τη δημιουργία και διαχείριση του λογαριασμού σας
- Για τη σύνδεση επιβατών με οδηγούς, την εμφάνιση της τοποθεσίας της διαδρομής σε πραγματικό χρόνο και την ολοκλήρωση των διαδρομών
- Για την είσπραξη πληρωμών, την πληρωμή των οδηγών και την τήρηση οικονομικών αρχείων
- Για την ασφάλεια, την υποστήριξη, τη διαχείριση παραπόνων και την πρόληψη της απάτης
- Για την αποστολή ενημερώσεων διαδρομής και μηνυμάτων σχετικά με την υπηρεσία
- Για την εκπλήρωση των νομικών και φορολογικών μας υποχρεώσεων
Οι νομικές βάσεις μας είναι: η εκτέλεση της σύμβασής μας μαζί σας, τα έννομα συμφέροντά μας (ασφάλεια, πρόληψη απάτης, βελτίωση της υπηρεσίας), οι νομικές υποχρεώσεις και η συγκατάθεσή σας όπου τη ζητάμε (για παράδειγμα άδεια τοποθεσίας και μάρκετινγκ). Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή.
## Με ποιους μοιραζόμαστε δεδομένα
- **Μεταξύ επιβατών και οδηγών:** τα στοιχεία που χρειάζονται για μια διαδρομή (μικρό όνομα, σημείο παραλαβής, τηλέφωνο επικοινωνίας, όχημα και τοποθεσία σε πραγματικό χρόνο)
- **Stripe:** πληρωμές με κάρτα και πληρωμές προς τους οδηγούς
- **Google Maps:** χάρτες, διευθύνσεις και διαδρομές
- **Πάροχοι φιλοξενίας, ειδοποιήσεων push και υποδομής εφαρμογών** που λειτουργούν τις εφαρμογές για εμάς
- **Αρχές:** όταν το απαιτεί ο νόμος
Δεν πουλάμε τα προσωπικά σας δεδομένα.
Ορισμένοι από αυτούς τους παρόχους ενδέχεται να επεξεργάζονται δεδομένα εκτός ΕΕ. Σε αυτή την περίπτωση, τα δεδομένα προστατεύονται με κατάλληλες εγγυήσεις, όπως οι Τυποποιημένες Συμβατικές Ρήτρες της ΕΕ.
## Πόσο καιρό διατηρούμε τα δεδομένα
Διατηρούμε τα δεδομένα του λογαριασμού σας όσο ο λογαριασμός σας είναι ενεργός. Τα αρχεία διαδρομών και πληρωμών διατηρούνται για όσο διάστημα απαιτεί η κυπριακή φορολογική και λογιστική νομοθεσία (συνήθως έως 6 χρόνια). Τα υπόλοιπα δεδομένα διαγράφονται ή ανωνυμοποιούνται όταν δεν χρειάζονται πλέον.
## Τα δικαιώματά σας
Έχετε δικαίωμα πρόσβασης, διόρθωσης, διαγραφής ή λήψης αντιγράφου των δεδομένων σας, δικαίωμα εναντίωσης ή περιορισμού της χρήσης τους, καθώς και δικαίωμα ανάκλησης της συγκατάθεσής σας. Για να ασκήσετε αυτά τα δικαιώματα, στείλτε email στο costataxicy@gmail.com.
Μπορείτε επίσης να υποβάλετε παράπονο στον Επίτροπο Προστασίας Δεδομένων Προσωπικού Χαρακτήρα στην Κύπρο (www.dataprotection.gov.cy).
## Διαγραφή του λογαριασμού σας
Μπορείτε να διαγράψετε τον λογαριασμό σας μέσα από την εφαρμογή (Προφίλ → Διαγραφή λογαριασμού) ή υποβάλλοντας αίτημα στο gettaxcy.com/delete-account ή μέσω email. Διαγράφουμε τον λογαριασμό σας εντός 30 ημερών. Ενδέχεται να διατηρήσουμε τα αρχεία διαδρομών και πληρωμών που υποχρεούμαστε από τον νόμο να τηρούμε.
## Παιδιά
Οι λογαριασμοί GetTaxcy προορίζονται για άτομα ηλικίας 18 ετών και άνω.
## Ασφάλεια
Χρησιμοποιούμε κρυπτογράφηση και ελέγχους πρόσβασης για την προστασία των δεδομένων σας. Κανένα σύστημα δεν είναι 100% ασφαλές, αλλά φροντίζουμε να διατηρούμε τα δεδομένα σας ασφαλή.
## Αλλαγές
Αν αλλάξουμε την παρούσα πολιτική, θα ενημερώσουμε την ημερομηνία στην κορυφή και θα σας ενημερώσουμε για σημαντικές αλλαγές μέσα από την εφαρμογή.
`,
  },
  terms: {
    meta: {
      title: "Όροι Χρήσης | GetTaxcy",
      description: "Όροι Χρήσης για την εφαρμογή επιβατών GetTaxcy και την εφαρμογή GetTaxcy Driver στην Κύπρο.",
    },
    md: `
# Όροι Χρήσης GetTaxcy
Τελευταία ενημέρωση: 3 Νοεμβρίου 2026
Οι παρόντες Όροι Χρήσης ισχύουν για την εφαρμογή επιβατών GetTaxcy, την εφαρμογή GetTaxcy Driver και την ιστοσελίδα gettaxcy.com. Δημιουργώντας λογαριασμό ή χρησιμοποιώντας το GetTaxcy, αποδέχεστε τους παρόντες όρους.
## Ποιοι είμαστε
Το GetTaxcy λειτουργεί από τον Γεώργιο Κεσίδη, με την εμπορική επωνυμία GetTaxcy.
Διεύθυνση: Διαγόρου 20, Κάτω Πάφος 8042, Κύπρος
Email: costataxicy@gmail.com
Τηλέφωνο / WhatsApp: +357 99940234
## Ποιος μπορεί να χρησιμοποιεί το GetTaxcy
Πρέπει να είστε τουλάχιστον 18 ετών για να δημιουργήσετε λογαριασμό GetTaxcy. Πρέπει να δίνετε ακριβή στοιχεία, να προστατεύετε τα στοιχεία σύνδεσής σας και είστε υπεύθυνοι για τη δραστηριότητα στον λογαριασμό σας.
## Η υπηρεσία μας
Το GetTaxcy είναι μια πλατφόρμα που συνδέει επιβάτες με ανεξάρτητους αδειούχους οδηγούς. Οι οδηγοί δεν είναι υπάλληλοι του GetTaxcy. Εκτελούν οι ίδιοι τις διαδρομές και είναι υπεύθυνοι για τις άδειες, την ασφάλεια και τα έγγραφα οχήματος που απαιτεί ο νόμος.
## Ναύλοι και πληρωμή
- Ο ναύλος εμφανίζεται στην εφαρμογή πριν επιβεβαιώσετε την κράτηση.
- Μπορείτε να πληρώσετε με κάρτα μέσω Stripe ή με μετρητά απευθείας στον οδηγό.
- Οι πληρωμές με κάρτα διεκπεραιώνονται από τη Stripe. Δεν βλέπουμε και δεν αποθηκεύουμε τον πλήρη αριθμό της κάρτας σας.
## Ακυρώσεις και μη εμφάνιση
Ενδέχεται να ισχύουν χρεώσεις ακύρωσης αν ακυρώσετε μια διαδρομή αφού έχει οριστεί οδηγός. Ενδέχεται να ισχύει χρέωση μη εμφάνισης αν ο οδηγός φτάσει στο σημείο παραλαβής και δεν εμφανιστείτε.
## Για τους οδηγούς
- Το GetTaxcy χρεώνει προμήθεια 12% επί του ναύλου για κάθε διαδρομή.
- Τα έσοδα των οδηγών καταβάλλονται εβδομαδιαία μέσω Stripe Connect.
- Οι οδηγοί πρέπει να διατηρούν πάντα σε ισχύ την άδεια οδήγησης και την άδεια ταξί, την άδεια κυκλοφορίας του οχήματος και την ασφάλεια.
## Συμπεριφορά
Επιβάτες και οδηγοί πρέπει να φέρονται ο ένας στον άλλο με σεβασμό και να ενεργούν πάντα νόμιμα. Δεν επιτρέπονται η βία, οι απειλές, η παρενόχληση, οι διακρίσεις, οι ζημιές σε οχήματα και κάθε παράνομη δραστηριότητα.
## Αναστολή λογαριασμών
Μπορούμε να αναστείλουμε ή να κλείσουμε λογαριασμούς που παραβιάζουν τους παρόντες όρους ή τον νόμο, ή που θέτουν σε κίνδυνο την ασφάλεια άλλων. Μπορείτε να διαγράψετε τον λογαριασμό σας ανά πάσα στιγμή στο gettaxcy.com/delete-account.
## Περιορισμός ευθύνης
Στο μέτρο που επιτρέπει ο νόμος, το GetTaxcy δεν ευθύνεται για έμμεσες ή αποθετικές ζημίες, ούτε για ζημίες που προκαλούνται από πράξεις ή παραλείψεις οδηγών, επιβατών ή τρίτων. Τίποτα στους παρόντες όρους δεν περιορίζει ευθύνη που δεν μπορεί να περιοριστεί βάσει νόμου, συμπεριλαμβανομένης της ευθύνης για θάνατο ή σωματική βλάβη από δική μας αμέλεια, ούτε τα νόμιμα δικαιώματά σας ως καταναλωτή.
## Εφαρμοστέο δίκαιο
Οι παρόντες όροι διέπονται από τους νόμους της Κυπριακής Δημοκρατίας. Τα δικαστήρια της Κύπρου είναι αρμόδια για κάθε διαφορά.
## Αλλαγές στους όρους
Μπορεί να ενημερώνουμε τους παρόντες όρους κατά καιρούς. Αν κάνουμε σημαντικές αλλαγές, θα ενημερώσουμε την ημερομηνία στην κορυφή και θα σας ενημερώσουμε μέσα από την εφαρμογή. Αν συνεχίσετε να χρησιμοποιείτε το GetTaxcy μετά από μια αλλαγή, αποδέχεστε τους ενημερωμένους όρους.
## Επικοινωνία
Ερωτήσεις για τους όρους: costataxicy@gmail.com ή +357 99940234.
`,
  },
  deletion: {
    meta: {
      title: "Διαγραφή λογαριασμού | GetTaxcy",
      description: "Πώς να διαγράψετε τον λογαριασμό επιβάτη ή οδηγού GetTaxcy και τα προσωπικά σας δεδομένα.",
    },
    md: `
# Διαγραφή του λογαριασμού σας
Μπορείτε να διαγράψετε τον λογαριασμό σας GetTaxcy ανά πάσα στιγμή, είτε χρησιμοποιείτε την εφαρμογή επιβατών GetTaxcy είτε την εφαρμογή GetTaxcy Driver.
## Επιλογή 1 – Μέσα από την εφαρμογή
Ανοίξτε την εφαρμογή και μεταβείτε στο **Προφίλ → Διαγραφή λογαριασμού**.
## Επιλογή 2 – Στείλτε μας αίτημα
Στείλτε αίτημα από τον εγγεγραμμένο αριθμό τηλεφώνου σας μέσω email στο costataxicy@gmail.com ή μέσω WhatsApp στο +357 99940234. Μπορείτε επίσης να χρησιμοποιήσετε τη φόρμα σε αυτή τη σελίδα.
## Τι γίνεται στη συνέχεια
- Διαγράφουμε τον λογαριασμό και τα προσωπικά σας δεδομένα εντός 30 ημερών.
- Τα αρχεία διαδρομών και πληρωμών που υποχρεούμαστε από τον νόμο να τηρούμε (έως 6 χρόνια) διατηρούνται για αυτό το διάστημα.
`,
    form: {
      title: "Αίτημα διαγραφής λογαριασμού",
      name: "Ονοματεπώνυμο",
      phone: "Εγγεγραμμένος αριθμός τηλεφώνου",
      email: "Email",
      role: "Τύπος λογαριασμού",
      passenger: "Επιβάτης",
      driver: "Οδηγός",
      reason: "Λόγος (προαιρετικό)",
      submit: "Αποστολή αιτήματος διαγραφής",
      sending: "Αποστολή…",
      success: "Ευχαριστούμε. Λάβαμε το αίτημά σας και θα διαγράψουμε τον λογαριασμό και τα προσωπικά σας δεδομένα εντός 30 ημερών.",
      error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά ή στείλτε email στο costataxicy@gmail.com.",
      required: "Συμπληρώστε το όνομα, τον αριθμό τηλεφώνου και ένα έγκυρο email.",
    },
  },
};
